import { List, Record } from 'immutable'
import { FEED_FILTER, FEED_RANGE, SECTION_ACTIVITIES_COMPLETED, TAB_RECENT } from 'app/constants/feed'

export const PendingRecord = Record({
  getLeaderBoard: false,
  getRecent: false,
  getRecentLoadMore: false,
  getStories: false,
  getStoriesLoadMore: false,
})

export class Pending extends PendingRecord {}

export const LoadedRecord = Record({
  getRecent: false,
  getRecentLoadMore: false,
  getStories: false,
  getStoriesLoadMore: false,
})

export class Loaded extends LoadedRecord {}

export const RecentPaginationRecord = Record({
  count: 0,
  limit: 100,
  page: 0,
})

export class RecentPagination extends RecentPaginationRecord {}

export const StoriesPaginationRecord = Record({
  count: 0,
  limit: 100,
  page: 0,
})

export class StoriesPagination extends StoriesPaginationRecord {}

export const FilterRecord = Record({
  byTeam: FEED_FILTER,
  byRange: FEED_RANGE.all,
})

export class Filter extends FilterRecord {}

const LeaderBoardListItemRecord = Record({
  byStreak: List(),
  byActivitiesCompleted: List(),
})

export class LeaderBoardListItem extends LeaderBoardListItemRecord {}

export const LeaderBoardRecord = Record({
  list: new LeaderBoardListItem(),
  section: SECTION_ACTIVITIES_COMPLETED,
})

export class LeaderBoard extends LeaderBoardRecord {}

export const ScrollTopRecord = Record({
  recent: 0,
  stories: 0,
})

export class ScrollTop extends ScrollTopRecord {}

export const AuthorRecord = Record({
  id: null,
  firstName: null,
  lastName: null,
})

export class Author extends AuthorRecord {}

export const FeedRecord = Record({
  leaderBoard: new LeaderBoard(),
  recent: List(),
  recentFromSocket: List(),
  stories: List(),
  pending: new Pending(),
  loaded: new Loaded(),
  tab: TAB_RECENT,
  recentPagination: new RecentPagination(),
  storiesPagination: new StoriesPagination(),
  scrollTop: new ScrollTop(),
  filter: new Filter(),
  unreadStoriesCount: 0,
  lastUnreadStoryAuthor: new Author(),
})

export class Feed extends FeedRecord {}
